import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVideo2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconVideo2"><Path d="M15.75 4.5C16.7165 4.5 17.5 5.2835 17.5 6.25V17.75C17.5 18.7165 16.7165 19.5 15.75 19.5H3.75C2.7835 19.5 2 18.7165 2 17.75V6.25C2 5.2835 2.7835 4.5 3.75 4.5H15.75Z" fill="currentColor"/><Path d="M20.4434 7.21484C21.4284 6.82118 22.4998 7.54658 22.5 8.60742V15.3926C22.4998 16.4534 21.4284 17.1788 20.4434 16.7852L18.5 16.0078V7.99219L20.4434 7.21484Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVideo2;
